
import {mapState} from 'vuex'


export default {


    data(){
        return {
            nav : [
                { name : '首页' , path : '/home' },
                { name : '新闻' , path : '/news' },
                { name : '产品' , path : '/product' },
                { name : '案例' , path : '/case' },
                { name : '关于' , path : '/about' },
            ],
            ov : false
        }
    },
    computed:mapState({
        flag : state => state.flag
    }),
    // watch:{
    //     $route(to){
    //       if(to.path == '/news/details' && this.flag){
    //         this.ov = true
    //       }else{
    //         this.ov = false
    //       }
    //     }
    // },
}